import { toast } from 'react-toastify';

/** Avertissement renvoyé par l'API avec un résultat. */
export interface AvertissementApi {
	codeErreur: string;
	message: string;
}

const CODE_DISPONIBLE_DEPASSE = 'erreur_disponible_depasse';

/** Message de l'API sur plusieurs lignes (ex. un dépassement de disponible par regroupement d'imputations). */
export const MessageMultiligne = ({ message }: { message: string }) => (
	<div style={{ whiteSpace: 'pre-line' }}>{message}</div>
);

/**
 * Affiche les dépassements de disponible non bloquants renvoyés par l'API (pièce enregistrée ou dupliquée,
 * duplication de bordereau lancée) : un message par pièce ou bordereau, une ligne par regroupement, affiché jusqu'à
 * ce que l'utilisateur le ferme. Un dépassement bloquant, lui, est une erreur de l'API.
 */
const afficherDepassementsDisponible = (warnings?: AvertissementApi[]) => {
	for (const warning of warnings ?? []) {
		if (warning.codeErreur === CODE_DISPONIBLE_DEPASSE) {
			toast.warning(<MessageMultiligne message={warning.message} />, {
				autoClose: false,
			});
		}
	}
};

export default afficherDepassementsDisponible;
